import isThenable from './isThenable';
import {stripTags, stripTagsEncoded} from './stripTags';
import decodeHtml from './decodeHtml';
import requestIdleCallback from './requestIdleCallback';
import cancelIdleCallback from './cancelIdleCallback';
import getVersion from './getVersion';
import isEmail from './isEmail';
import {isUri} from './isUri';
import isEqualSet from './isEqualSet';
import isNil from './isNil';
import svgToDataUri from './svgToDataUri';

export {
    decodeHtml,
    getVersion,
    isThenable,
    isUri,
    isEmail,
    isNil,
    isEqualSet,
    stripTags,
    stripTagsEncoded,
    svgToDataUri,
    cancelIdleCallback,
    requestIdleCallback
};
